import { FunctionComponent, useEffect } from 'react';
import Footer from '../shared/footer/footer';
import TopMenu from '../shared/top-menu/top-menu';
import DIV from '../shared/html-tags/div';
import { Helmet } from 'react-helmet-async';

export type Props = {};

const Legal: FunctionComponent<Props> = (props) => {
  useEffect(() => {
    const usercentrics = document.querySelector('#usercentrics-root') as HTMLElement;
    if (usercentrics) {
      usercentrics.style.opacity = '0';
      console.log('removed');
    }
  }, []);
  useEffect(() => {
    return () => {
      const usercentrics = document.querySelector('#usercentrics-root') as HTMLElement;
      if (usercentrics) {
        usercentrics.style.opacity = '1';
        console.log('restored');
      }
    };
  }, []);
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <>
      <Helmet>
        <title>PS IMAGO PRO - Impressum</title>
        <meta
          name="description"
          content="Impressum der 2x4 Solutions GmbH, Anbieter von PS IMAGO PRO. Kontaktinformationen, USt-ID und rechtliche Hinweise."
        />
        <meta
          name="keywords"
          content="Impressum, 2x4 Solutions GmbH, PS IMAGO PRO, rechtliche Hinweise, Kontaktinformationen"
        />
        <link rel="canonical" href="https://predictivesolutions.2x4.de/de/legal" />
      </Helmet>
      <div className="page">
        <TopMenu selected="legal"></TopMenu>

        <DIV language="de">
          <div className="page-content bg-top2">
            <div className="inner-content">
              <h1>Impressum</h1>
            </div>
          </div>

          <div className="page-content bg-1">
            <div className="inner-content">
              <p>
                2x4 Solutions GmbH
                <br />
                Fichtenring 8<br />
                84562 Mettenheim
              </p>

              <p>Handelsregister Traunstein: HRB 22887</p>

              <p>
                <strong>Vertreten durch:</strong>
                <br />
                Bernhard Witt
              </p>

              <h2>Kontakt</h2>
              <p>
                Telefon: +49 8631 607164
                <br />
                Fax: Nicht verfügbar
                <br />
                E-mail: info@2x4.de
              </p>

              <h2>UST ID</h2>
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
                <br />
                DE291029487
              </p>

              <h2>Redaktionell verantwortlich</h2>
              <p>
                Bernhard Witt
                <br />
                Fichtenring 8<br />
                84562 Mettenheim
              </p>

              <h2>EU-Streitschlichtung</h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
                bereit:{' '}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br /> Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>

              <h2 style={{ wordWrap: 'break-word' }}>
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </div>
        </DIV>
        <DIV language="en">
          <div className="page-content bg-top2">
            <div className="inner-content">
              <h1>Legal Notice</h1>
            </div>
          </div>

          <div className="page-content bg-1">
            <div className="inner-content">
              <p>
                2x4 Solutions GmbH
                <br />
                Fichtenring 8<br />
                84562 Mettenheim
              </p>

              <p>
                Commercial Register: HRB 22887
                <br />
                Registration court: Traunstein
              </p>

              <p>
                <strong>Represented by:</strong>
                <br />
                Bernhard Witt
              </p>

              <h2>Contact</h2>
              <p>
                Phone: +49 8631 607164
                <br />
                E-mail: info@2x4.de
              </p>

              <h2>VAT ID</h2>
              <p>
                Sales tax identification number according to Sect. 27 a of the Sales Tax Law:
                <br />
                DE291029487
              </p>

              <h2>Person responsible for editorial</h2>
              <p>
                Bernhard Witt
                <br />
                Fichtenring 8<br />
                84562 Mettenheim
              </p>

              <h2>EU dispute resolution</h2>
              <p>
                The European Commission provides a platform for online dispute resolution (ODR):{' '}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br /> Our e-mail address can be found above in the site notice.
              </p>

              <h2>Dispute resolution proceedings in front of a consumer arbitration board</h2>
              <p>
                We are not willing or obliged to participate in dispute resolution proceedings in
                front of a consumer arbitration board.
              </p>
            </div>
          </div>
        </DIV>
        <Footer hideCookieSettings={true} />
      </div>
    </>
  );
};

export default Legal;
